module.exports = __webpack_public_path__ + "assets/icons/ic_error-8341.svg";